/**
 * 문자열 seed → 결정적(deterministic) 색상. 같은 seed 는 항상 같은 색.
 *
 * 동일 사용자/사이트가 어디서나 같은 색을 갖도록 (이름/도메인 등 seed → 7색 팔레트).
 * AuthorChip(작성자 아바타)과 SiteLinksBar(관련 사이트 칩)가 공유한다.
 */
const PALETTE = ['#1976d2', '#388e3c', '#f57c00', '#7b1fa2', '#c62828', '#0097a7', '#5d4037'];

export function colorFromSeed(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export default colorFromSeed;
